import axios from 'axios';
import {token} from '../services/Authentication'

class UserService {

  static user(companies) {
    
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_URL_MEDIASIM}/usuario/todos`,
      headers: {        
        "content-type": "application/json",
        "authorization": token(), 
      },
      data: companies,
    })
    .then((res) => res, (error) => error)

  }

}


export default UserService;